import type { RoleAssignment } from '@/apiServices/types';

interface FormatUserRolesOptions {
  separator?: string;
  unique?: boolean;
  sorted?: boolean;
}

// Defaults reproduce the admin Users grid's original output exactly, so its cell, sort key and CSV
// export are unaffected. Session replay opts into unique + sorted so one role set always yields one
// filter value.
export function formatUserRoles(
  assignments?: RoleAssignment[],
  { separator = ', ', unique = false, sorted = false }: FormatUserRolesOptions = {},
): string {
  const names = (assignments ?? [])
    .map((assignment) => assignment.role?.roleName?.trim())
    .filter((name): name is string => !!name);

  const selected = unique ? [...new Set(names)] : names;

  return (sorted ? [...selected].sort() : selected).join(separator);
}
